import { styled } from '@mui/material';

import { YamlContainer } from './components/YamlContainer';
import { PreviewYamlProps } from './types';
import { shouldForwardProp } from '../../../utils/shouldForwardProp';
import { CodeErrorBoundary } from '../_components';
import { PreviewConfigProvider } from '../_providers';

const Root = styled('div', {
  name: 'DsPreviewYaml',
  slot: 'Root',
  target: 'DsPreviewYaml-root',
  shouldForwardProp,
  overridesResolver: (_, styles) => [styles.root],
})<{ ownerState: PreviewYamlProps }>({});

export const PreviewYaml = ({
  testId = 'yaml-preview',
  ...props
}: PreviewYamlProps) => {
  props = {
    ...props,
    size: props.size ?? 'lg',
    errorMessage: props.errorMessage ?? 'Cannot display YAML',
  };
  return (
    <PreviewConfigProvider {...props}>
      <Root ownerState={props} sx={props.rootSx} data-testid={testId}>
        <CodeErrorBoundary>
          <YamlContainer {...props} />
        </CodeErrorBoundary>
      </Root>
    </PreviewConfigProvider>
  );
};
